import './App.css';
import { AppContextProvider } from './AppContext';
import GameBox from './Components/GameBox';
import Keyboard from './Components/Keyboard';
import Results from './Components/Results';
import ScoreAndInfo from './Components/ScoreAndInfo';

function App() {
  return (
    <AppContextProvider>
      <div className='bg-gray-800 min-h-screen App relative flex items-center justify-center m-auto w-full overflow-auto'>
        <ScoreAndInfo />
        <div style={{ maxWidth: '600px' }} className='flex w-full flex-col mt-14'>
          <h1 className='text-white text-2xl mt-4'>Wordle Türkçe | 2 Wordle Bir Arada</h1>
          <div className='flex flex-row flex-wrap my-10 md:my-20 justify-center'>
            <div className='flex overflow-auto w-full'>
              <GameBox className='mr-2' id={'wordOne'} />
              <GameBox id={'wordTwo'} />
            </div>
            <div className='flex flex-col justify-between mb-4 md:my-4 w-full'>
              <Keyboard />
              <Results />
            </div>
          </div>
        </div>
      </div>
    </AppContextProvider>
  );
}

export default App;
